module.exports = __webpack_public_path__ + "b1ae4946377e57f997172d5dab12b2bb.svg";